export enum Filters {
  All,
  Particle,
  Neuron,
  LLM,
}
